import { attr, belongsTo } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
export default EmberDataBaseModel.extend({
  nickname: attr('string'),
  email: attr('string'),
  password: attr('string'),
  token: attr('string'),
  depositTag: attr('string'),
  frozen: attr('boolean', {
    defaultValue: false
  }),
  unitActive: attr('boolean', {
    defaultValue: true
  }),
  canAcceptPaymentCards: attr('boolean'),
  canAcceptBitcoin: attr('boolean'),
  hasAfterpayOnline: attr('boolean'),
  linkedBankAccountFideliusToken: attr('string'),
  bankAccount: belongsTo('bank-account'),
  merchantProfile: belongsTo('merchant-profile', {
    async: false
  }),
  activationAddress: fragment('squareup/common/location/address'),
  business_type: attr('string')
}).reopenClass({
  _modelNameForMigration: 'merchant-subunit-detailed'
});